import { useEffect, useState } from 'react'

import AnimatedLetters from '../AnimatedLetters'
import usePageMeta from '../../utils/usePageMeta'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  usePageMeta({
    title: 'About Greg Chui – Full-stack & AI Engineer',
    description:
      'Greg Chui builds web products end to end: React and Next.js front ends, Node.js and Python APIs, and LLM-powered features with RAG and agents.',
    path: '/about',
  })

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 1500)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <span className="sr-only">About me</span>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm a full-stack engineer who builds web products end to end: fast,
            accessible interfaces in React and Next.js, APIs in Node.js and Python
            (FastAPI, Django), and data layers on PostgreSQL, MongoDB and Redis.
          </p>
          <p>
            A growing part of my work is AI. I integrate LLM APIs, build
            retrieval-augmented generation (RAG) pipelines and agent workflows with
            tool use, and turn them into reliable features real users depend on.
            I also use AI tooling in my own workflow to ship faster without giving
            up quality.
          </p>
          <p>
            I care about code that's clean, readable, well tested and split into
            small pieces that make sense, whether that's a UI component, an API
            endpoint or a prompt pipeline.
          </p>
          <p>
            Outside of work I'm a family person, sports fanatic, cooking
            enthusiast, and tech-obsessed!
          </p>
        </div>
      </div>
    </>
  )
}

export default About